import { render, staticRenderFns } from "./DetailSquad.vue?vue&type=template&id=244ecc14"
import script from "./DetailSquad.vue?vue&type=script&lang=js"
export * from "./DetailSquad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports